export enum ViewState {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    EMPTY = 'EMPTY',
    NO_DATA = 'NO_DATA',
    OPT_OUT = 'OPT_OUT',
}
